import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Box, Typography } from "@mui/material";

function TicketsMessageNotFound() {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" mt={10}>
      <ErrorOutlineIcon color="info" fontSize="large" />
      <Typography variant="h6" mt={2}>
        Nenhuma ordem de serviço encontrada.
      </Typography>
      <Typography variant="body2" color="text.secondary" mt={1}>
        No momento, você não possui ordens de serviço cadastradas.
      </Typography>
    </Box>
  );
}

export default TicketsMessageNotFound;
